// tslint:disable:curly

import { Injectable } from '@angular/core';
import { ArcService } from './arc.service';
import { ExportItem } from './export-item';
import { DbRecordService } from './db-record.service';
import { DbRecord } from './db-record';
import { Observable }  from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { RuntimeService } from './runtime.service';
import { TagService } from './tag.service';

@Injectable()
export class ExportParserService {
  tags: TagService;

  constructor(
    private arcs: ArcService,
    private dbrs: DbRecordService,
    private rs: RuntimeService,

  ) { }

  initFiles(ls: Object[], excludeRecordIds) {
    let originalDct = {};
    let jsonDct = {};
    this.dbrs.currentExcludeRecordsSet  = new Set<string>(excludeRecordIds || []);

    ls.forEach((x) => {
      let fn = x['filename'].split('/').pop();
      if (fn.endsWith('.json'))
        jsonDct[fn.slice(0, -5)] = x;
      else
        originalDct[fn] = x;
    });

    let obs;
    let startObs;
    for (let k of Object.keys(jsonDct)) {
      obs = this.downloadExportFile(jsonDct[k], true);
      if (startObs)
        startObs = startObs.merge(obs);
      else
        startObs = obs;
    }

    for (let k of Object.keys(originalDct))
      if (!jsonDct[k]) {
        obs = this.downloadExportFile(originalDct[k], false);
        if (startObs)
          startObs = startObs.merge(obs);
        else
          startObs = obs;
      }

    if (startObs)
      startObs.last().subscribe(() => this.dbrs.prepareLists());
    else
      this.rs.currentProject.isInitialized = true;
  }

  exportCSVToFile(dbrls: DbRecord[]) {
    let ls = [DbRecord.exportForCSVHeaders()];
    dbrls.forEach((x) => {
      ls.push(x.exportForCSV());
    });

    // console.log(ls.join('\n\n').slice(0,10000))
    this.saveExport(require('javascript-csv').fromArrays(ls), 'export.csv');
  }

  exportJSONToFile(dbrls: DbRecord[]) {
    let ls = [];
    dbrls.forEach((x) => {
      ls.push(x.exportForJSON());
    });
    // console.log(ls.join('\n\n').slice(0,10000))
    this.saveExport(JSON.stringify({
      records: ls,
      tags: this.tags.exportJSON()
    }), 'export.json');
  }

  exportHTMLToFile(dbrls: DbRecord[]) {
    let ls = [];
    dbrls.forEach((x) => {
      ls.push(x.exportForHTML());
    });
    // console.log(ls.join('\n\n').slice(0,10000))
    this.saveExport(ls.join('\n\n'), 'export.html');
  }


  exportToFile(dbrls: DbRecord[]) {
    let ls = [];
    dbrls.forEach((x) => {
      ls.push(x.export());
    });
    // console.log(ls.join('\n\n').slice(0,10000))
    this.saveExport(ls.join('\n\n'), 'export.ris');
  }

  saveExport(data, filename) {
    var hiddenElement = document.createElement('a');
    hiddenElement.href = URL.createObjectURL(new Blob([data], { type: 'text/plain' }));
    hiddenElement.target = '_blank';
    hiddenElement.download = filename;
    hiddenElement.click();
    hiddenElement.remove();
  }

  processExport(ls: Object[], pth: string) {
    let suffix = pth.split('@')[1];
    let isFamily = false;
    if (suffix) {
      suffix = suffix.split('.')[0];
      isFamily = suffix.indexOf('FAMILY') >= 0;
    }
    let dbrLs = [];

    ls.forEach((x) => {
      dbrLs.push(this.dbrs.create(x));
    });

    if (isFamily)
      this.dbrs.processPatentFamily(dbrLs);
  }

  downloadExportFile(obj: Object, isJson: boolean): Observable<any> {
    let s = new Subject<any>();
    let pth = obj['filename'];

    let obs = this.arcs.run({
      fun: 'downloadExportFile',
      isDownload: true,
      path: pth
    });
    obs.subscribe((resp) => {
      if (isJson) {
        this.processExport(JSON.parse(resp), pth);
        s.next(true);
        s.complete();
        return;
      }

      let data = this.parse_conductor(resp, obj['filename']);
      if (!data || !data.length) {
        s.next(true);
        s.complete();
        return;
      }

      let obs2 = this.arcs.run({
        fun: 'saveExportFile',
        data: data,
        path: `${obj['filename']}.json`
      });
      obs2.subscribe((x) => console.log(x));
      this.processExport(data, pth);
      s.next(true);
      s.complete();
    });
    return s;
  }

  parse_espacenet_export(arg: Object): Object[] {
    console.log('ESPACENET PARSING');
    let results: Object[] = [];
    let ei;
    let eiArg = { tp: 'espacenet', searchCode: arg['searchCode'] };
    require('javascript-csv').toObjects(arg['txt']).forEach(x => {
      ei = new ExportItem(eiArg);
      ei.title = x['Title'];
      ei.applicationNumber = x['Application number'];
      ei.priorityNumber = x['Priority number(s)'];
      ei.publicationNumber = x['Publication number'];
      let d = x['Date of application'];
      ei.year = d.slice(0, 4);
      ei.otherDate = d;
      ei.otherDate = x['Publication date'];
      ei.ipc = x['International classification'];
      ei.cpc = x['Cooperative Patent Classification'];
      ei.finalize(results);
      console.log(x);
      // console.log(ei)
    });

    return results;
  }

  parse_pubmed_export(arg: Object): Object[] {
    console.log('PUBMED PARSING');
    let results: Object[] = [];
    let txt = arg['txt'];
    let ei;
    let tag;
    let doiTest = /\[doi\]/;
    let eiArg = { tp: 'pubmed', searchCode: arg['searchCode'] };
    for (let ln of txt.split('\n')) {
      let txt = ln.slice(6).trim();
      if (!txt)
        continue;
      let newTag = ln.slice(0, 4).trim();
      if (newTag)
        tag = newTag;
      switch (tag) { // https://www.nlm.nih.gov/bsd/mms/medlineelements.html
        case 'AB': ei.abstract = txt; break;
        case 'AD': ei.address = txt; break;
        case 'AID':
          if (doiTest.test(txt))
            ei.doi = txt.split('[')[0].trim();
          else
            ei.keyword = txt;
          break;
        case 'AU': ei.author = txt; break;
        case 'CI': ei.misc = txt; break;
        case 'CIN': ei.keyword = txt; break;
        case 'CRDT': ei.otherDate = txt; break;
        case 'DA': ei.otherDate = txt; break;
        case 'DCOM': ei.otherDate = txt; break;
        case 'DP': ei.year = txt; break;
        case 'DEP': ei.year = txt; break;
        case 'EDAT': ei.misc = txt; break;
        case 'EIN': ei.misc = txt; break;
        case 'FAU': ei.fullAuthor = txt; break;
        case 'GR': ei.keyword = txt; break;
        case 'IP': ei.issue = txt; break;
        case 'IS': ei.issn = txt; break;
        case 'JID': ei.keyword = txt; break;
        case 'JT': ei.source = txt; break;
        case 'LA': ei.lang = txt; break;
        case 'LID':
          if (doiTest.test(txt))
            ei.doi = txt.split('[')[0].trim();
          else
            ei.keyword = txt;
          break;
        case 'LR': ei.otherDate = txt; break;
        case 'MH': ei.keyword = txt; break;
        case 'MHDA': ei.misc = txt; break;
        case 'MID': ei.keyword = txt; break;
        case 'NLM': ei.keyword = txt; break;
        case 'OID': ei.keyword = txt; break;
        case 'OT': ei.keyword = txt; break;
        case 'OTO': ei.misc = txt; break;
        case 'OWN': ei.misc = txt; break;
        case 'PG': ei.startPage = txt; break;
        case 'PL': ei.misc = txt; break;
        case 'PHST': ei.misc = txt; break;
        case 'PMC': ei.keyword = txt; break;
        case 'PMID': if (ei) ei.finalize(results);
          ei = new ExportItem(eiArg);
          ei.recordId = txt;
          break;
        case 'PT': ei.type = txt; break;
        case 'PST': ei.type = txt; break;
        case 'RF': ei.misc = txt; break;
        case 'RN': ei.keyword = txt; break;
        case 'SO': ei.misc = txt; break;
        case 'SB': ei.misc = txt; break;
        case 'STAT': ei.misc = txt; break;
        case 'TA': ei.abbrevSource = txt; break;
        case 'TI': ei.title = txt; break;
        case 'TT': ei.title = txt; break;
        case 'VI': ei.volume = txt; break;
        case 'VTI': ei.volume = txt; break;
        default: console.log(tag, txt);
      }
    }
    ei.finalize(results);
    return results;
  }

  parse_wos_export(arg: Object): Object[] {
    console.log('WOS');
    let results: Object[] = [];
    let txt = arg['txt'];
    let eiArg = { tp: 'wos', searchCode: arg['searchCode'] };
    let ei = new ExportItem(eiArg);
    let tag;
    for (let ln of txt.split('\n')) { // http://images.webofknowledge.com/WOKRS49B3/help/WOK/hft_wos.html
      if (!ln)
        continue;
      let newTag = ln.slice(0, 2).trim();
      if (newTag)
        tag = newTag;
      let txt = ln.slice(3).trim();
      switch (tag) {
        case 'AB': ei.abstract = txt; break;
        case 'AF': ei.fullAuthor = txt; break;
        case 'AR': ei.articleNumber = txt; break;
        case 'AU': ei.author = txt; break;
        case 'BE': ei.author = txt; break;
        case 'BP': ei.startPage = txt; break;
        case 'BN': ei.isbn = txt; break;
        case 'C1': ei.address = txt; break;
        case 'CT': ei.conference = txt; break;
        case 'CY': ei.conference = txt; break;
        case 'CL': ei.conference = txt; break;
        case 'DE': ei.keyword = txt; break;
        case 'DC': ei.misc = txt; break;
        case 'DI': ei.doi = txt; break;
        case 'DT': ei.type = txt; break;
        case 'EF': break;
        case 'EI': ei.issn = txt; break;
        case 'EM': ei.misc = txt; break;
        case 'EP': ei.endPage = txt; break;
        case 'FU': ei.misc = txt; break;
        case 'FN': ei.misc = txt; break;
        case 'FX': ei.misc = txt; break;
        case 'GA': ei.misc = txt; break;
        case 'GP': ei.misc = txt; break;
        case 'HO': ei.address = txt; break;
        case 'ID': ei.keyword = txt; break;
        case 'IS': ei.issue = txt; break;
        case 'JI': ei.abbrevSource = txt; break;
        case 'J9': ei.abbrevSource = txt; break;
        case 'LA': ei.lang = txt; break;
        case 'NR': ei.misc = txt; break;
        case 'OI': ei.misc = txt; break;
        case 'PA': ei.misc = txt; break;
        case 'PD': ei.otherDate = txt; break;
        case 'PG': ei.misc = txt; break;
        case 'PI': ei.misc = txt; break;
        case 'PM': ei.misc = txt; break;
        case 'PN': ei.misc = txt; break;
        case 'PT': ei.type = txt; break;
        case 'PU': ei.misc = txt; break;
        case 'PY': ei.year = txt; break;
        case 'RI': ei.misc = txt; break;
        case 'RP': ei.address = txt; break;
        case 'SI': ei.misc = txt; break;
        case 'SC': ei.misc = txt; break;
        case 'SE': ei.misc = txt; break;
        case 'SN': ei.issn = txt; break;
        case 'SO': ei.source = txt; break;
        case 'SP': ei.misc = txt; break;
        case 'TC': ei.misc = txt; break;
        case 'TI': ei.title = txt; break;
        case 'UT': ei.recordId = txt; break;
        case 'U1': ei.misc = txt; break;
        case 'U2': ei.misc = txt; break;
        case 'VL': ei.volume = txt; break;
        case 'VR': ei.misc = txt; break;
        case 'WC': ei.misc = txt; break;
        case 'Z9': ei.misc = txt; break;
        case 'ER': ei.finalize(results); ei = new ExportItem(eiArg); break;
        default:
          console.log(tag, txt);
      }
    }
    return results;
  }

  parse_scopus_export(arg: Object): Object[] {
    console.log('SCOPUS PARSING');
    let results: Object[] = [];
    let txt = arg['txt'];
    let eiArg = { tp: 'scopus', searchCode: arg['searchCode'] };
    let ei = new ExportItem(eiArg);
    let cTest = /C\d/;
    for (let ln of txt.split('\n')) {
      ln = ln.trim();
      if (!ln)
        continue;
      let txt = ln.slice(6);
      let tag = ln.slice(0, 2);
      switch (tag) { // https://en.wikipedia.org/wiki/RIS_(file_format)
        case 'AB': ei.abstract = txt; break;
        case 'AD': ei.address = txt; break;
        case 'AU': ei.author = txt; break;
        case 'A2': ei.author = txt; break;
        case 'CY': ei.address = txt; break;
        case 'DB': ei.dbName = txt; break;
        case 'DO': ei.doi = txt; break;
        case 'EP': ei.endPage = txt; break;
        case 'C7': ei.articleNumber = txt; break;
        case 'IS': ei.issue = txt; break;
        case 'J2': ei.abbrevSource = txt; break;
        case 'KW': ei.keyword = txt; break;
        case 'LA': ei.lang = txt; break;
        case 'M3': ei.workType = txt; break;
        case 'N1': ei.misc = txt; break;
        case 'PB': ei.publisher = txt; break;
        case 'PY': ei.year = txt; break;
        case 'SN': ei.issn = txt; break;
        case 'SP': ei.startPage = txt; break;
        case 'ST': ei.title = txt; break;
        case 'T2': ei.source = txt; break;
        case 'TI': ei.title = txt; break;
        case 'TY': ei.type = txt; break;
        case 'UR': ei.recordId = txt; break;
        case 'VL': ei.volume = txt; break;
        case 'ER': ei.finalize(results); ei = new ExportItem(eiArg); break;
        default:
          if (cTest.test(tag)) {
            ei.misc = txt;
            break;
          }
          console.log(tag, txt);
      }
    }
    return results;
  }

  parse_cas_export(arg: Object): Object[] {
    console.log('CAS');
    let results: Object[] = [];
    let eiArg = { tp: 'cas', searchCode: arg['searchCode'] };
    let ei = new ExportItem(eiArg);
    let txt = arg['txt'];
    for (let ln of txt.split('\n')) {
      ln = ln.trim();
      if (!ln)
        continue;
      let txt = ln.slice(6);
      let tag = ln.slice(0, 2);
      switch (tag) {
        // case "AD": ei.address = txt; break;
        case 'AU': ei.author = txt; break;
        // case "DB": ei.dbName = txt; break;
        // case "DO": ei.doi = txt; break;
        case 'EP': ei.endPage = txt; break;
        case 'IS': ei.issue = txt; break;
        // case "J2": ei.abbrevSource = txt; break;
        // case "KW": ei.keyword = txt; break;
        case 'JF': ei.source = txt; break;
        case 'LA': ei.lang = txt; break;
        // case "M3": ei.workType = txt; break;
        case 'N1': ei.recordId = txt; break;
        case 'N2': ei.abstract = txt; break;
        // case "N1": ei.misc = txt; break;
        // case "PB": ei.publisher = txt; break;
        case 'PY': ei.year = txt; break;
        // case "SN": ei.issn = txt; break;
        case 'SP': ei.startPage = txt; break;
        // case "ST": ei.title = txt; break;
        case 'T1': ei.title = txt; break;
        case 'TY': ei.type = txt; break;
        case 'VL': ei.volume = txt; break;
        case 'ER': ei.finalize(results); ei = new ExportItem(eiArg); break;
        // default: console.log(tag, txt);
        //   if (cTest.test(tag)) {
        //     ei.misc = txt;
        //     break;
      }
    }
    return results;
  }

  parse_proquest_export(arg: Object): Object[] {
    console.log('PROQUEST');
    let results: Object[] = [];
    let eiArg = { tp: 'proquest', searchCode: arg['searchCode'] };
    let ei = new ExportItem(eiArg);
    let txt = arg['txt'];
    for (let ln of txt.split('\n')) {
      ln = ln.trim();
      if (!ln)
        continue;
      let txt = ln.slice(6);
      let tag = ln.slice(0, 2);
      switch (tag) {
        // case "AD": ei.address = txt; break;
        case 'AU': ei.author = txt; break;
        // case "DB": ei.dbName = txt; break;
        // case "DO": ei.doi = txt; break;
        case 'EP': ei.endPage = txt; break;
        case 'IS': ei.issue = txt; break;
        // case "J2": ei.abbrevSource = txt; break;
        // case "KW": ei.keyword = txt; break;
        case 'JF': ei.source = txt; break;
        case 'LA': ei.lang = txt; break;
        // case "M3": ei.workType = txt; break;
        case 'AN': ei.recordId = txt; break;
        case 'AB': ei.abstract = txt; break;
        // case "N1": ei.misc = txt; break;
        // case "PB": ei.publisher = txt; break;
        case 'PY': ei.year = txt; break;
        case 'SN': ei.issn = txt; break;
        case 'SP': ei.startPage = txt; break;
        // case "ST": ei.title = txt; break;
        case 'T1': ei.title = txt; break;
        case 'TY': ei.type = txt; break;
        case 'VL': ei.volume = txt; break;
        case 'ER': ei.finalize(results); ei = new ExportItem(eiArg); break;
        default: console.log(tag, txt);
        //   if (cTest.test(tag)) {
        //     ei.misc = txt;
        //     break;
      }
    }
    return results;
  }

  parse_manual_export(arg: Object) {
    console.log('MANUAL');
    return this.parse_cas_export(arg);
  }

  getSearchCode(path) {
    try {
      let code = path.split('@').pop().split('.')[0];
      return code.slice(code.indexOf('R'));
    } catch (e) {
      console.log('NO SEARCH CODE');
      return '';
    }
  }

  parse_conductor(txt: string, path: string): Object[] {
    console.log(111);
    let searchCode = this.getSearchCode(path);
    console.log(222);
    if (!(/^R\d{13,}/).test(searchCode))
      console.log('SERCH CODE FAULT', searchCode);
    console.log(333, path);
    txt = txt.trim();
    let arg = { txt: txt, searchCode: searchCode };
    if (path.indexOf('-proquest-') > -1)
      return this.parse_proquest_export(arg);
    if (txt.startsWith('"Title"'))
      return this.parse_espacenet_export(arg);

    if (txt.startsWith('FN Thomson') || txt.startsWith('FN Clarivate')
      || txt.startsWith('FN BIBLIO'))
      return this.parse_wos_export(arg);
    if (txt.startsWith('PMID-'))
      return this.parse_pubmed_export(arg);
    let lead = txt.slice(0, 10000);
    if (lead.indexOf('?eid=2-s2') > -1)
      return this.parse_scopus_export(arg);
    if (lead.indexOf('N1  -') > -1)
      return this.parse_cas_export(arg);
    if (lead.indexOf('manual_') > -1)
      return this.parse_manual_export(arg);
    console.log('FORMAT NOT RECOGNIZED', `|||${lead}|||`);
    return null;
  }


}



// WEBPACK FOOTER //
// ./src/app/export-parser.service.ts